import { render, staticRenderFns } from "./ticketDetailFcp.vue?vue&type=template&id=aabe8de0&lang=pug"
import script from "./ticketDetailFcp.vue?vue&type=script&lang=js"
export * from "./ticketDetailFcp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports